import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Modal, Button, Colors } from 'advenio-components'

var ModalContent = styled.div`
  padding: 24px;
  text-align: center;
`

var Title = styled.h3`
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 700;
  color: #212B36;
`

var DocumentName = styled.p`
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: ${Colors.blue500};
`

var Warning = styled.p`
  margin: 0 0 24px 0;
  font-size: 14px;
  color: #E53935;
  font-weight: 500;
`

var ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
`

class DeleteConfirmationModal extends Component {
  render () {
    var props = this.props

    return (
      <Modal
        isOpened={props.isOpen}
        onClose={props.onClose}
        title='Eliminar documento'
      >
        <ModalContent>
          <Title>¿Estás seguro que deseas eliminar este documento?</Title>
          <DocumentName>{props.documentName}</DocumentName>
          <Warning>Esta acción no se puede deshacer</Warning>
          <ButtonContainer>
            <Button
              default
              onClick={props.onClose}
              disabled={props.deleting}
            >
              Cancelar
            </Button>
            <Button
              primary
              onClick={props.onConfirm}
              loading={props.deleting}
              disabled={props.deleting}
            >
              Eliminar
            </Button>
          </ButtonContainer>
        </ModalContent>
      </Modal>
    )
  }
}

DeleteConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  documentName: PropTypes.string,
  deleting: PropTypes.bool
}

DeleteConfirmationModal.defaultProps = {
  documentName: '',
  deleting: false
}

export default DeleteConfirmationModal



// WEBPACK FOOTER //
// ./src/Components/Documents/DeleteConfirmationModal/index.jsx